import React, { useState } from 'react'
import { Icon, Modal } from 'semantic-ui-react'

import { preconUserId } from 'environment'

import { useAppSelector } from 'redux/hooks'

import { FORMAT } from 'types/deck'

import PreconSelector from 'components/deckPage/misc/EmptyDeckLanding/PreconSelector'

import { Button } from './style'

const FORMATS_WITH_PRECONSTRUCTED = [FORMAT.EDH]

const ImportFromPrecon = () => {
  const { format } = useAppSelector(state => state.deck)

  const [isOpen, setIsOpen] = useState(false)

  const handleClose = () => setIsOpen(false)

  if (!FORMATS_WITH_PRECONSTRUCTED.includes(format)) return null
  if (preconUserId === null) return null

  return (
    <>
      <Modal style={{ minHeight: '95%' }} open={isOpen} onClose={handleClose} closeIcon>
        <div style={{ margin: '1rem' }}>
          <PreconSelector format={format} onClose={handleClose} />
        </div>
      </Modal>
      <Button onClick={() => setIsOpen(true)}>
        <Icon name="download" link style={{ color: '#0094f7' }} size="massive" />
        <h4>Preconstructed Decks</h4>
      </Button>
    </>
  )
}

export default ImportFromPrecon
